var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.48 12.834-.835.802c-.151.146-.454.036-.454-.182v-.146c0-.364.038-.692.113-1.057l1.479-5.686c.19-.765-.19-1.567-.986-1.75-.758-.181-1.478.293-1.668 1.058l-1.326 6.123.151-6.633c0-.802-.568-1.458-1.364-1.458-.796 0-1.364.656-1.364 1.458l.151 6.815-1.175-6.196c-.19-.765-.872-1.239-1.63-1.057-.758.183-1.137.948-.947 1.713l1.402 5.722-1.97-3.353c-.38-.546-1.062-.729-1.593-.328-.53.365-.606 1.094-.227 1.64l1.82 2.916c.34.51.53 1.13.53 1.75v.62c0 2.368 1.895 4.3 4.245 4.3h1.1a4.449 4.449 0 0 0 3.145-1.312l4.624-4.665c.303-.292.341-.584.265-.912-.151-.583-.606-1.13-1.288-1.13-.683 0-1.668.402-2.199.948Z",
    stroke: "#222",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.721 17.69c-.339-1.224.723-3.118 2.694-3.118M19.718 8.587c.512-1.182.012-2.182-.718-2.682M21.774 8.905c.553-1.763.014-3.255-.774-4M3.304 12.326c-.33 1.246.314 2.16 1.111 2.545M1.223 12.32c-.282 1.826.474 3.22 1.364 3.84",
    stroke: "#222",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.18782a65.svg";
export { ForwardRef as ReactComponent };